import NetworkCall from "network/networkCall";
import Request from "network/request";
import {
  camelCaseKeys,
  camelCaseKeysRecursively,
} from "utilities/generalUtility";

export default class Invoice {
  static async edit(values, showError = true) {
    const res = await NetworkCall.fetch(
      Request.editInvoice(values),
      false,
      showError,
    );
    return camelCaseKeys(res.data);
  }

  static async getInvoiceDetail(id) {
    const res = await NetworkCall.fetch(Request.getInvoiceDetails(id));
    return camelCaseKeysRecursively(res.data);
  }

  static async delete(values) {
    const res = await NetworkCall.fetch(Request.deleteInvoice(values));
    return camelCaseKeys(res.data);
  }

  static async bulkUpdate(body) {
    const res = await NetworkCall.fetch(Request.bulkUpdateInvoice(body));
    return camelCaseKeys(res.data);
  }

  static v2 = {
    getAll: async (params) => {
      return NetworkCall.fetch(Request.v2.getInvoices(params));
    },
    getJobBills: async (id, params, useLoading = true) => {
      return NetworkCall.fetch(Request.v2.getInvoiceJobBills(id, params), useLoading);
    },
  };
}
